<script setup lang="ts">
defineOptions({
	name: 'CircleNotSelectedIcon',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'w-14',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 57 58"
		:class="props.class"
	>
		<rect
			x="0.98294"
			y="0.479645"
			width="54.652"
			height="56.7418"
			rx="27.326"
			stroke="currentColor"
			stroke-width="0.960266"
			stroke-dasharray="7 7"
			fill="none"
		/>
	</svg>
</template>
